<template>
  <div class="search" v-if="currentOption" v-click-outside-element="closeSearch">
    <h1 @click="toggleSearch()" data-qa="search-title-toggle"><span>{{ currentPharmName }}</span> <vita-icon :class="{spin: openDrop}" class="search__icon" name="chevron-circle-bottom"/></h1>
    <div class="search__drop" v-if="openDrop">
      <vita-input v-model="search" type="text" icon="search" :placeholder="currentPharmName" :oninput="onSearchInput"
                  data-qa="search-input-query"/>
      <div class="search__drop-empty" v-if="pharmsList.data.length == 0">Результатов не найдено</div>
      <div class="search__options" v-else>
        <div class="search__option" :class="{'disabled' : inProcess}" v-for="item in currentOptions" @click="selected(item)" :key="item.name + item.id"
             data-qa="search-option-select">{{formatPharmName(item.name)}}</div>
      </div>
      <div class="arrows__pagination" v-if="!inSearch && hasArrows && (hasPrevArrow() || hasNextArrow())">
        <div>
          <button class="arrows__pagination-item" type="button" @click="prevPage()" v-if="hasPrevArrow()" :disabled="inProcess"
                  data-qa="search-button-page-prev">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.16927 4.75964L4.76221 7.16671L7.16927 9.57377L7.63883 9.10421L6.03467 7.50004H9.7526V6.83337H6.03467L7.63883 5.22921L7.16927 4.75964ZM7.16648 4.00543e-05C8.14805 4.00543e-05 9.07451 0.186422 9.94585 0.559186C10.8172 0.931964 11.5802 1.44531 12.2347 2.09923C12.8893 2.75314 13.4031 3.51535 13.7762 4.38583C14.1494 5.25633 14.3359 6.18236 14.3359 7.16392C14.3359 8.15937 14.1496 9.0893 13.7768 9.95371C13.404 10.8181 12.8907 11.5776 12.2367 12.2321C11.5828 12.8867 10.8206 13.4005 9.95015 13.7737C9.07965 14.1468 8.15362 14.3334 7.17206 14.3334C6.1766 14.3334 5.24667 14.147 4.38227 13.7742C3.51787 13.4015 2.75839 12.8881 2.10383 12.2342C1.44929 11.5803 0.935452 10.8215 0.562313 9.958C0.189174 9.09444 0.00260353 8.16494 0.00260353 7.1695C0.00260353 6.18793 0.188986 5.26147 0.561749 4.39012C0.934527 3.51878 1.44787 2.75583 2.10179 2.10127C2.75571 1.44673 3.51444 0.932887 4.37798 0.559748C5.24153 0.186609 6.17103 4.00543e-05 7.16648 4.00543e-05ZM7.16927 0.666707C5.36372 0.666707 3.82899 1.29865 2.5651 2.56254C1.30122 3.82643 0.669271 5.36115 0.669271 7.16671C0.669271 8.97226 1.30122 10.507 2.5651 11.7709C3.82899 13.0348 5.36372 13.6667 7.16927 13.6667C8.97483 13.6667 10.5095 13.0348 11.7734 11.7709C13.0373 10.507 13.6693 8.97226 13.6693 7.16671C13.6693 5.36115 13.0373 3.82643 11.7734 2.56254C10.5095 1.29865 8.97483 0.666707 7.16927 0.666707Z" fill="#888888"/>
            </svg>
          </button>
        </div>

       <div>
         <button class="arrows__pagination-item" type="button" @click="nextPage()" v-if="hasNextArrow()" :disabled="inProcess"
                 data-qa="search-button-page-next">
           <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M7.83073 4.75964L10.2378 7.16671L7.83073 9.57377L7.36117 9.10421L8.96533 7.50004H5.2474V6.83337H8.96533L7.36117 5.22921L7.83073 4.75964ZM7.83352 4.00543e-05C6.85195 4.00543e-05 5.92549 0.186422 5.05415 0.559186C4.1828 0.931964 3.41985 1.44531 2.76529 2.09923C2.11075 2.75314 1.59691 3.51535 1.22377 4.38583C0.850632 5.25633 0.664062 6.18236 0.664062 7.16392C0.664062 8.15937 0.850445 9.0893 1.22321 9.95371C1.59599 10.8181 2.10933 11.5776 2.76325 12.2321C3.41717 12.8867 4.17937 13.4005 5.04985 13.7737C5.92035 14.1468 6.84638 14.3334 7.82794 14.3334C8.8234 14.3334 9.75333 14.147 10.6177 13.7742C11.4821 13.4015 12.2416 12.8881 12.8962 12.2342C13.5507 11.5803 14.0645 10.8215 14.4377 9.958C14.8108 9.09444 14.9974 8.16494 14.9974 7.1695C14.9974 6.18793 14.811 5.26147 14.4383 4.39012C14.0655 3.51878 13.5521 2.75583 12.8982 2.10127C12.2443 1.44673 11.4856 0.932887 10.622 0.559748C9.75847 0.186609 8.82897 4.00543e-05 7.83352 4.00543e-05ZM7.83073 0.666707C9.63628 0.666707 11.171 1.29865 12.4349 2.56254C13.6988 3.82643 14.3307 5.36115 14.3307 7.16671C14.3307 8.97226 13.6988 10.507 12.4349 11.7709C11.171 13.0348 9.63628 13.6667 7.83073 13.6667C6.02517 13.6667 4.49045 13.0348 3.22656 11.7709C1.96267 10.507 1.33073 8.97226 1.33073 7.16671C1.33073 5.36115 1.96267 3.82643 3.22656 2.56254C4.49045 1.29865 6.02517 0.666707 7.83073 0.666707Z" fill="#888888"/>
           </svg>
         </button>
       </div>
      </div>
    </div>
    <div class="search__address-wrap">
      <p class="search__address" :title="currentOption.webAddress">{{currentOption.webAddress}}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VitaInput from "@/components/UI/VitaInput.vue"
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import { Option } from '@/types';
import {useStore} from "vuex";
import { getPharmacies } from '@/utils/pharmacy';

const store = useStore()
interface Props {
  options: Option[],
  modelValue: Option | undefined
}
const props = defineProps<Props>()

const currentOption = ref<Option>()
const search = ref<string>('')
const openDrop = ref<boolean>(false)
const currentOptions = ref<Array<Option>>()
const savedOptions = ref()
const inProcess = ref<boolean>(false)
const inSearch = ref<boolean>(false)
const hasArrows = ref<boolean>(false)
const oldSearchQuery = ref<string>('')

const formatPharmName = (pharmId: string) => 'Аптека № ' + pharmId

const currentPharmName = computed<string>(() => {
  return currentOption.value ? formatPharmName(currentOption.value.name) : ''
})

const pharmId = computed<number>(() => {
  return store.getters['data/pharmId']
})

const pharmsList = computed(() => {
  return store.getters['data/pharmsList']
})

const pharmsListCount = computed<number>(() => {
  return store.getters['data/pharmsListCount']
})

const pharmsSearchQuery = computed(() => {
  return store.getters['data/pharmsSearchQuery']
})

const hasUnsavedChanges = computed(() => {
  return store.getters['hasUnsavedChanges']
})

const toggleSearch = () => {
  openDrop.value = !openDrop.value
}

const closeSearch = () => {
  openDrop.value = false
  // Добавлена проверка на search.value из-за ошибки получения аптек после перезагрузки
  if (search.value.length > 0 && (oldSearchQuery.value !== search.value)) {
    store.commit('data/setPharmSearchQuery', oldSearchQuery.value)
    oldSearchQuery.value ? localStorage.setItem('pharmSearch', oldSearchQuery.value) : null
  }
}

const searchOption = async () => {
  oldSearchQuery.value = pharmsSearchQuery.value || localStorage.getItem('pharmSearch')

  if (pharmsListCount.value) {
    inSearch.value = true
    inProcess.value = true

    // Если ищем в открытой аптеке не на первой странице - переходим на первую страницу результатов
    if (Number(localStorage.getItem('pharmSkip')) > 0 || pharmsList.value.meta.skip > 0) {
      store.commit('data/setPharmQueryValue', 0)
    }

    store.commit('data/setPharmSearchQuery', search.value)
    try {
      await store.dispatch('data/getPharmsSearchList', search.value);
      currentOptions.value = []
      currentOptions.value = pharmsList.value.data
    } catch {
      if (localStorage.getItem('token')) console.error('Ошибка при поиске');
    } finally {
      inSearch.value = false
      inProcess.value = false
    }

    if (pharmsList.value.meta.count > 10) {
      hasArrows.value = true
    }
  }
}

// Задержка для запросов при вводе пользователя
let debounceTimer: number;

watch(search, () => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  debounceTimer = setTimeout(() => {
    searchOption();
  }, 500);
});

const selected = (item: Option) => {
  if (hasUnsavedChanges.value) {
    // Если выполняется переход на другую аптеку и добавлен новый внешний сотрудник - запрашиваем подтверждение
    const leaveConfirm = window.confirm('Есть несохраненные изменения на графике, перейти на другую аптеку?')

    if (leaveConfirm) {
      store.commit('setUnsavedChanges', false)
    } else {
      return false
    }
  }

  store.commit('data/setPharmId', item.id)
  store.commit('data/setUsers', item.id)
  currentOption.value = item
  openDrop.value = false
  localStorage.setItem('pharmId', item.id.toString())
  localStorage.setItem('pharmSkip', pharmsList.value.meta.skip)
  localStorage.setItem('pharmSearch', search.value)
  // Очистка поиска внешних пользователей при переходе между аптеками
  store.commit('data/setUserSearchSkip', 0)
  store.commit('data/setUserSearchList', null)

  currentOptions.value?.forEach((option, index) => {
    if (option.id === item.id) {
      currentOptions.value?.splice(index, 1)
      currentOptions.value?.unshift(item)
    }
  })
  getPharmacies()
}

const getItemById = (selectedId: number) => {
  return currentOptions.value?.find((item) => item.id === selectedId);
}

const hasPrevArrow = () => {
  return !(pharmsList.value.length !== 0 && pharmsList.value.meta.skip === 0);
}

const hasNextArrow = () => {
  return !(pharmsList.value.length !== 0 && pharmsList.value.meta.count === (pharmsList.value.meta.skip + 10) || (pharmsList.value.meta.skip + 10 > pharmsList.value.meta.count));
}

const prevPage = async () => {
  inProcess.value = true
  store.commit('data/decreasePharmQuery')
  await store.dispatch("data/getPharmsSearchList", search.value);
  currentOptions.value = []
  currentOptions.value = pharmsList.value.data
  inProcess.value = false
}

const nextPage = async () => {
  inProcess.value = true
  store.commit('data/increasePharmQuery')
  await store.dispatch("data/getPharmsSearchList", search.value);
  currentOptions.value = []
  currentOptions.value = pharmsList.value.data
  inProcess.value = false
}

const onSearchInput = () => {
  inProcess.value = true
}

onBeforeMount(() => {
  if (pharmsListCount.value > 10) {
    hasArrows.value = true
  }

  if (pharmsSearchQuery.value || localStorage.getItem('pharmSearch')) {
    search.value = pharmsSearchQuery.value || localStorage.getItem('pharmSearch')
  }

  currentOptions.value = props.options || []
  savedOptions.value = currentOptions.value
  currentOption.value = getItemById(pharmId.value);
})

onMounted(() => {
  if (!currentOption.value) {
    store.commit('data/closeErrorDialog', 'Ошибка получения списка аптек')
  }
})
</script>

<style scoped lang="scss">
@use '../static/style/variables.scss' as *;
@use '../static/style/mixins.scss' as *;

.search {
  position: relative;

  &__icon {
    transition: .3s;
    transform: rotate(0deg);
    &.spin {
      transform: rotate(180deg);
    }
  }

  h1 {
    display: inline-flex;
    align-items: center;
    margin-bottom: 4px;
    cursor: pointer;

    span {
      margin-right: 16px;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
      color: #333333;
    }
  }

  &__drop {
    position: absolute;
    background: #fff;
    width: 225px;
    top: 28px;
    padding: 10px;
    z-index: 5;
    box-shadow: 2px 2px 12px 0 #0000001A;
    user-select: none;

    input::placeholder {
      color: $text-color-light;
    }

    &-empty {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 11px;
      line-height: 13px;
      color: #BBBBBB;
      margin-top: -20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 33px;
    }
  }

  &__options {
    overflow: auto;
    max-height: 438px;
    margin-top: -20px;
    padding: 0 10px;
  }

  &__option {
    padding: 10px 0;
    @include font_2;
    cursor: pointer;
    transition: opacity .35s;

    &.disabled {
      opacity: .5;
      pointer-events: none;
    }

    &:hover {
      color: $blue;
    }
  }
}

.arrows__pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px;

  > div {
    display: flex;
  }

  &-item {
    background: unset;
    border: 0;
    width: 15px;
    height: 15px;
    cursor: pointer;

    &[disabled] {
      opacity: .5;
      pointer-events: none;
    }
  }
}

.search__address-wrap {
  min-height: 15px;
}

.search__address {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #333333;
}
</style>
